import React from "react";
import { Modal, Button, Menu, Grid, Table } from "semantic-ui-react";
import { Trans, useTranslation } from "react-i18next";
import { format } from "date-fns";

import { FORMAT_DATE, FORMAT_TIME } from "../../../common/dateFormats";

import InformationContainer from "./information/InformationContainer";
import RegistrationsContainer from "./registrations/RegistrationsContainer";
import RegisterContainer from "../register/RegisterContainer";
import CancelContainer from "../cancel/CancelContainer";

function Details({
  showModal,
  trainingUnit,
  handleClose,
  onUpdateTrainingUnit,
  selectedView,
  selectView,
  isAdminView,
  onRefreshData
}) {
  const { t } = useTranslation();

  return (
    <Modal
      open={showModal}
      size={"large"}
      onClose={handleClose}
      centered={false}
    >
      <Modal.Header as="h1" color="blue">
        {trainingUnit.courseDate.course.title}
      </Modal.Header>
      <Modal.Content>
        {isAdminView ? (
          <>
            <Table basic="very" collapsing celled>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>
                    {trainingUnit.courseDate.location.name}
                    {trainingUnit.courseDate.room &&
                      ` (${t("courses.labels.room")}: ${
                        trainingUnit.courseDate.room
                      })`}
                  </Table.Cell>
                  <Table.Cell>
                    {format(new Date(trainingUnit.date), FORMAT_DATE)}{" "}
                    {format(new Date(trainingUnit.date), FORMAT_TIME)}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <Grid stackable>
              <Grid.Column width={4}>
                <Menu fluid vertical>
                  <Menu.Item
                    name="registrations"
                    active={selectedView === "registrations"}
                    onClick={selectView("registrations")}
                  >
                    <Trans i18nKey="coursePlan.details.menu.registrations" />
                  </Menu.Item>
                  <Menu.Item
                    name="info"
                    active={selectedView === "info"}
                    onClick={selectView("info")}
                  >
                    <Trans i18nKey="coursePlan.details.menu.info" />
                  </Menu.Item>
                </Menu>
              </Grid.Column>
              <Grid.Column width={12}>
                {selectedView === "info" && (
                  <InformationContainer
                    onUpdateTrainingUnit={onUpdateTrainingUnit}
                    trainingUnit={trainingUnit}
                    isAdminView={isAdminView}
                  />
                )}

                {selectedView === "registrations" && (
                  <RegistrationsContainer
                    onUpdateTrainingUnit={onUpdateTrainingUnit}
                    trainingUnit={trainingUnit}
                  />
                )}
              </Grid.Column>
            </Grid>
          </>
        ) : (
          <InformationContainer trainingUnit={trainingUnit} />
        )}
      </Modal.Content>
      {isAdminView ? (
        <Modal.Actions style={{ textAlign: "left" }}>
          <Button type="button" onClick={handleClose}>
            <Trans i18nKey="coursePlan.details.actions.close" />
          </Button>
        </Modal.Actions>
      ) : (
        <Modal.Actions>
          {trainingUnit.isRegistered ? (
            <CancelContainer
              trainingUnitId={trainingUnit.id}
              canCancel={trainingUnit.canCancel}
              courseTitle={trainingUnit.courseDate.course.title}
              trainingUnitDate={trainingUnit.date}
              isOnWaitingList={trainingUnit.waitingListPosition > 0}
              onFinished={onRefreshData}
            />
          ) : (
            <RegisterContainer
              trainingUnit={trainingUnit}
              onFinished={onRefreshData}
            />
          )}

          <Button floated="left" type="button" onClick={handleClose}>
            <Trans i18nKey="coursePlan.details.actions.close" />
          </Button>
        </Modal.Actions>
      )}
    </Modal>
  );
}

Details.displayName = "coursePlan/details/Details";

export default React.memo(Details);
